<template>
    <v-layout justify-center>
        <v-responsive max-width="1240" width="100%" height="100%" class="px-3 mx-n3">
            <list-heading title="배너관리">
                <template #subtitle>
                    <div class="caption primary--text">* PC 배너 사이즈 1920*590(px) / 모바일 배너 사이즈 1920*590(px)</div>
                </template>
            </list-heading>

            <v-data-table v-bind="{ headers, items, loading }" :items-per-page="-1" disable-pagination disable-sort hide-default-footer class="v-sheet--outlined">
                <template #[`item.name`]="{ item }">
                    <div style="line-height: 1">
                        {{ item.name }} <br />
                        <span class="caption"> {{ item.code }} </span>
                    </div>
                </template>
                <template #[`item.createdAt`]="{ item }">
                    {{ item.createdAt ? item.createdAt.toDate() : "" }}
                </template>
                <template #[`item.slides`]="{ item }">
                    <v-img v-for="(slide, index) in item.slides.filter((slide) => slide.image)" :key="index" :src="slide.image" max-width="96" max-height="96" contain class="d-inline-block" />
                </template>
                <template #[`item.shows`]="{ item }">
                    <v-switch v-model="item.shows" inset color="primary" hide-details dens class="ma-0 pa-0 ml-1 mr-n3 d-inline-block" @change="update({ _id: item._id, shows: item.shows })"></v-switch>
                </template>
                <template #[`item.actions`]="{ item }">
                    <v-btn :to="`/console/banners/${item?._id}`" x-small icon text class="mr-2">
                        <v-icon small> mdi-pencil </v-icon>
                    </v-btn>
                    <v-icon small @click="remove(item)">mdi-delete</v-icon>
                </template>
            </v-data-table>
            <v-pagination :value="page" :length="pageCount" :total-visible="11" color="primary" class="my-2" @input="(page) => $router.push({ query: { ...$route.query, page } })" />
        </v-responsive>

        <v-btn color="primary" fab fixed right bottom to="/console/banners/create"><v-icon>mdi-pencil</v-icon></v-btn>
    </v-layout>
</template>

<script>
import api from "@/api";

import ListHeading from "@/components/console/dumb/list-heading.vue";

const headers = [
    { width: 240, text: "명칭", value: "name" },
    { text: "슬라이드", value: "slides" },
    { width: +80, text: "영역노출", value: "shows", align: "center" },
    { width: +80, text: "", value: "actions" },
].map((item, index, array) => ({ ...item, formatter: item.formatter ?? ((value) => value ?? "-"), divider: index != array.length - 1, class: (item.class || "") + " white-space-pre-line", cellClass: (item.cellClass || "") + " py-2" }));

export default {
    components: {
        ListHeading,
    },
    created() {
        this.init();
    },
    data: () => ({
        banners: [],

        limit: 10,
        summary: { totalCount: 0 },

        headers,
        loading: false,
    }),
    computed: {
        items() {
            return [...this.banners];
        },
        page() {
            return +(this.$route.query.page || "1");
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        params() {
            let { ...query } = this.$route.query;
            return { ...query };
        },
    },
    watch: {
        params() {
            this.search();
        },
    },
    methods: {
        async init() {
            try {
                await this.search();
            } catch (error) {
                console.error(error);
                if (error.response) alert(error.response.data.message);
            }
        },

        async search() {
            if (this.loading) return;
            else this.loading = true;

            try {
                let { skip, limit, params } = this;

                var { summary, banners } = await api.console.banners.gets({
                    headers: { skip, limit },
                    params,
                });

                this.summary = summary;
                this.banners = banners;
            } finally {
                this.loading = false;
            }
        },

        async update(banner) {
            if (this.loading) return;
            else this.loading = true;

            try {
                await api.console.banners.put(banner);
                this.search();
            } finally {
                this.loading = false;
            }
        },

        async remove(banner) {
            if (confirm("배너를 삭제하시겠습니까?")) {
                await api.console.banners.delete(banner);
                await this.search();
            }
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .line-height-1-5 {
        line-height: 1.5;
    }
    .max-width-0 {
        max-width: 0;
    }
    .white-space-pre-line {
        white-space: pre-line;
    }
    .cursor-pointer {
        cursor: pointer;
    }
    .v-pagination button {
        box-shadow: none !important;
        border: thin solid rgba(0, 0, 0, 0.12);
    }
    .v-small-dialog__activator__content {
        width: 100%;
    }

    .memo-area {
        height: auto !important;

        .v-btn__content {
            display: block;
            text-align: initial;
            white-space: pre-line;
            text-transform: initial;
        }
    }
}
</style>
